import Link from "next/link";
import Image from "next/image";
import AboutUsImage from "@/images/about-us-photo.png";
import { useTranslation } from "next-i18next";
import { trackApplyButton } from '@/utils/dataLayer';

const OurGoals = () => {
    const { t } = useTranslation();

    return (
        <div
            id="our-goals"
            className="flex flex-col-reverse lg:flex-row items-center justify-between gap-[40px] lg:gap-[80px] bg-white max-w-[90%] md:py-[80px] pt-[40px] pb-[100px] mx-auto"
        >
            <div className="flex-1 flex flex-col gap-[12px] md:gap-[20px] w-full min-w-[50%]">
                <div className="flex flex-col gap-[12px] md:gap-[20px]">
                    <h3 className="text-[18px] md:text-[28px] font-[600] leading-[120%] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">
                        {t("navlinks.about-us")}
                    </h3>
                    <h1 className="text-[32px] md:text-[42px] lg:text-[48px] xl:text-[54px] 2xl:text-[64px] font-[600] leading-[120%] text-main-pink">
                        {t("about-us-page.our-goals-title")}
                    </h1>
                    <h2 className="text-[24px] sm:text-[32px] lg:text-[40px] font-[600] leading-[120%] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">
                        {t("about-us-page.our-goals-subtitle")}
                    </h2>
                </div>

                <div className="flex flex-col gap-[12px] md:gap-[20px] pr-0 xl:pr-[80px]">
                    <p className="text-[16px] md:text-[14px] font-[400] leading-[160%] text-gray-700">
                        {t("about-us-page.our-goals-description-1")}
                    </p>

                    <p
                        className="text-[16px] md:text-[14px] font-[400] leading-[160%] text-gray-700"
                        dangerouslySetInnerHTML={{ __html: t("about-us-page.our-goals-description-2") }}
                    />
                </div>

                <div className="flex flex-col sm:flex-row gap-[16px] sm:gap-[20px] pt-[12px] md:pt-[20px]">
                    <Link href="/apply" className="w-full md:w-[220px]" onClick={() => trackApplyButton("our_goals")}>
                        <button className="relative flex md:h-[56px] h-[48px] w-full items-center justify-center rounded-full bg-gradient-to-b from-[#091F59] to-[#1A3884] px-[12px] text-[16px] font-[500] text-white overflow-hidden group transition-all duration-300 hover:text-[#091F59] border border-transparent hover:border-[#091F59]">
                            <span className="relative z-10">{t("apply-btn")}</span>
                            <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full"></span>
                        </button>
                    </Link>
                </div>
            </div>

            <div className="relative flex flex-col items-center justify-center gap-[20px]">
                <div className="w-full flex items-center justify-center">
                    <Image
                        src={AboutUsImage}
                        alt="About Us"
                        width={540}
                        height={566}
                        loading="lazy"
                    />
                </div>
            </div>
        </div>
    );
};

export default OurGoals;
